<script setup lang="ts">
import type { UniquePost } from "@/server/api/types";
import { ROUTE_BLOG_CATEGORY } from "~/constants/routes";

const { replaceParams } = useRouteParams();
const props = defineProps<{
  relatedPosts: UniquePost[];
}>();

const randomPosts = computed(() => props.relatedPosts.slice(0, 3));
</script>
<template>
  <div class="flex flex-col gap-4 justify-center overflow-x-hidden">
    <div class="flex gap-4 justify-center w-full flex-col md:flex-row p-2 items-center">
      <article
        v-for="post in randomPosts" :key="post.id"
        class="text-desktop-subheader-l w-[80%] md:w-[30%] rounded-[12px] bg-primary-cream-100 post-card my-2">
        <nuxt-link
          :to="post.link" class="max-h-[276px] bg-cover bg-no-repeat bg-center rounded-t-[12px]"
          :style="{
            backgroundImage: `url(${post.featuredImage})`,
          }" />
        <div class="py-7 px-7">
          <div class="flex flex-row gap-1 mt-2 flex-wrap">
            <template v-for="(category) in post.categories" :key="category?.name">
              <nuxt-link
                :to="{ path: replaceParams(ROUTE_BLOG_CATEGORY, { slug: category?.slug }) }"
                rel="category tag">
                <div
                  class="px-2 py-1 bg-none hover:bg-tertiary-misc-limeade transition-all rounded-xl outline outline-1 outline-offset-[-1px] outline-primary-spinach-500 inline-flex justify-center items-center">
                  <div class="justify-center text-primary-spinach-500 text-desktop-body-xs uppercase">
                    {{ category?.name }}</div>
                </div>
              </nuxt-link>
            </template>
          </div>
          <h2 class="text-desktop-subheader-l my-4 hover:text-primary-spinach-500">
            <nuxt-link :to="post.link">{{ post.title }}</nuxt-link>
          </h2>
          <div class="text-desktop-body-s mb-4" v-html="post.excerpt" />
          <nuxt-link
            :to="post.link"
            class="text-desktop-button-l text-primary-spinach-500 hover:text-primary-spinach-700">Read
            more</nuxt-link>
        </div>
      </article>
    </div>
  </div>

</template>
